import { ReactNode } from "react";
import { Box, PaperProps, Typography } from "@mui/material";

import { If } from "@/features/shared/components";

import {
  CenteredContent as StyledCenteredContent,
  CenteredContentTitle,
  PageContainer,
  PageHeader as StyledPageHeader,
} from "./styled";

export { PageContainer };

type PageHeaderProps = {
  children?: ReactNode;
  title: string;
};

export const PageHeader = ({ title, children }: PageHeaderProps) => (
  <StyledPageHeader>
    <Typography variant="h4">{title}</Typography>
    {children}
  </StyledPageHeader>
);

interface CenteredContentProps extends PaperProps {
  children?: ReactNode;
  title?: string;
  color?: "error";
  right?: ReactNode;
}

export const CenteredContent = ({
  children,
  title,
  color,
  right,
  ...passedProps
}: CenteredContentProps) => (
  <StyledCenteredContent elevation={0} {...passedProps}>
    <If condition={title}>
      <CenteredContentTitle color={color}>
        <Typography>{title}</Typography>
        {right}
      </CenteredContentTitle>
    </If>
    <Box sx={{ px: 3 }}>{children}</Box>
  </StyledCenteredContent>
);
